export const ROUTE_ROOT = '';
export const ROUTE_DRIVER_DASHBOARD = '';
export const ROUTE_PROFILE = 'profile';
export const ROUTE_NOTIFICATIONS = 'notifications';
export const ROUTE_ACCOUNT_SETTINGS = 'accountSettings';
export const ROUTE_TELL_A_FRIEND = 'tellFriend';
export const ROUTE_DRIVER_HISTORY = 'driverHistory';
export const ROUTE_REGISTRATION = 'registration';
export const ROUTE_LOADS = 'loads';
